// Per person-type labels and form keys for the generic PersonListSection. The fields
// themselves come from the form schema. The API's `personTypes` object (formKey/
// sectionKey/label/plural) wins over the values here when present.

export const PERSON_TYPES = {
  Trader: {
    type: "Trader",
    formKey: "traders",
    sectionKey: "G",
    title: "Appointed Traders' Knowledge and Experience",
    subtitle: "Each appointed trader should complete the following information and sign",
    singular: "Appointed trader",
    plural: "Appointed traders",
  },
  Signatory: {
    type: "Signatory",
    formKey: "signatories",
    sectionKey: "SIGNATORIES",
    title: "Non-dealing Signatories",
    subtitle: "Signatories authorised to instruct non-dealing matters",
    singular: "Non-dealing signatory",
    plural: "Non-dealing signatories",
  },
  Director: {
    type: "Director",
    formKey: "directors",
    sectionKey: "DIRECTORS",
    title: "Directors",
    subtitle: "Directors of the account holder",
    singular: "Director",
    plural: "Directors",
  },
  UBO: {
    type: "UBO",
    formKey: "ubos",
    sectionKey: "UBOS",
    title: "Ultimate Beneficial Owners",
    subtitle: "Natural persons who ultimately own or control the account holder",
    singular: "Ultimate beneficial owner",
    plural: "Ultimate beneficial owners",
  },
  Officer: {
    type: "Officer",
    formKey: "officers",
    sectionKey: "OFFICERS",
    title: "Officers",
    subtitle: "Officers of the account holder",
    singular: "Officer",
    plural: "Officers",
  },
  SubFund: {
    type: "SubFund",
    formKey: "subFunds",
    sectionKey: "SUBFUNDS",
    title: "Sub-funds",
    subtitle: "Sub-funds trading under this account",
    singular: "Sub-fund",
    plural: "Sub-funds",
  },
};

export const PERSON_TYPE_KEYS = Object.keys(PERSON_TYPES);

// Merges the API's labels over the local defaults for one type.
export function personConfig(type, apiPersonTypes) {
  const local = PERSON_TYPES[type];
  if (!local) return null;
  const remote = (apiPersonTypes && apiPersonTypes[type]) || {};
  return {
    ...local,
    personType: type,
    formKey: remote.formKey || local.formKey,
    sectionKey: remote.sectionKey || local.sectionKey,
    singular: remote.label || local.singular,
    plural: remote.plural || local.plural,
  };
}

